<template>
	<div class="container">
		<!--  顶部用户信息  -->
		<div class="head-bar g-flex g-row-center">
			<div class="total-width g-flex">
				<img :src="userInfo.avatar?userInfo.avatar:$store.state.defaultAvatar" class="avatar" alt="">
				<div class="g-m-l-30">
					<div class="g-flex">
						<p class="g-font-28 white-text g-weight-font">{{userInfo.realName}}</p>
						<div class="status-tag g-font-12 g-m-l-15" v-if="workStatusName!=''">{{workStatusName}}
						</div>
					</div>
					<div class="g-flex g-m-t-15" v-if="userInfo.diplomaName">
						<p class="white-text g-font-14">
							<span>{{userInfo.diplomaName}}</span>
							<span class="g-m-l-10 g-m-r-10">|</span>
							<span>{{userInfo.workingSeniorityName}}年经验</span>
							<span class="g-m-l-10 g-m-r-10" v-if="!!salary">|</span>
							<span>{{salary}}</span>
						</p>
						<p class="g-m-l-30 g-font-14">
							<span class="white-text">已学习</span>
							<span class="yellow-text g-m-l-10">{{ studyData.studyTime }}</span>
						</p>
					</div>
				</div>
				<div class="g-flex-right g-flex">
					<div class="g-text-center">
						<p class="white-text">
							<span class="g-weight-font g-font-36">{{ studyData.certificateCount }}</span>
							<span class="g-font-14 g-m-l-10">个</span>
						</p>
						<p class="g-m-t-2 sub-color g-font-14">已获证书</p>
					</div>
					<div class="str-line"></div>
					<div class="g-text-center">
						<p class="white-text">
							<span class="g-weight-font g-font-36">{{ studyData.courseCount }}</span>
							<span class="g-font-14 g-m-l-10">门</span>
						</p>
						<p class="g-m-t-2 sub-color g-font-14">已学课程</p>
					</div>
					<div class="str-line"></div>
					<div class="g-text-center">
						<p class="white-text">
							<span class="g-weight-font g-font-36">{{ studyData.starCount }}</span>
							<span class="g-font-14 g-m-l-10">颗</span>
						</p>
						<p class="g-m-t-2 sub-color g-font-14">获得星级</p>
					</div>
				</div>
			</div>
		</div>

		<!--  菜单 详情  -->
		<div class="g-flex g-m-t-30 g-row-center">
			<div class="g-flex total-width g-col-top">
				<!--  菜单  -->
				<div class="left-menu">
					<div class="menu-title g-flex g-row-center white-text g-font-18">
						个人中心
					</div>
					<div class="menu-body">
						<div class="g-rela menu-item pointer g-flex g-row-center g-font-16 main-text"
							:class="{'active-menu':index === menuIndex}" v-for="(item,index) in menuList " :key="index"
							@click="mineMenuChange(index)">
							{{ item }}
							<!--  消息数  -->
							<div class="nums" v-if="index === 1 && totalNews>0">
								<!-- {{ totalNews>99?'99+':totalNews }} -->
							</div>
						</div>
					</div>
				</div>
				<!--  内容  -->
				<div class="g-m-l-20 main-info">
					<!--  个人信息  -->
					<div v-if="menuIndex === 0">
						<user-info :user="userInfo" @update="updateUserInfo"></user-info>
					</div>
					<!--  消息中心  -->
					<div v-if="menuIndex === 1">
						<news-center></news-center>
					</div>
					<!--  我的简历  -->
					<div v-if="menuIndex === 2">
						<my-resume></my-resume>
					</div>
					<!--  我的收藏、投递  -->
					<div v-if="menuIndex === 3">
						<send-collection></send-collection>
					</div>
					<!--  我的课程  -->
					<div v-if="menuIndex === 4">
						<my-course></my-course>
					</div>
					<!--  我的考试  -->
					<div v-if="menuIndex === 5">
						<my-exam @checkPaper="mineMenuChange(6)"></my-exam>
					</div>
					<!--  我的认证  -->
					<div v-if="menuIndex === 6">
						<my-papers></my-papers>
					</div>
					<!--  我的订单  -->
					<div v-if="menuIndex === 7">
						<my-order></my-order>
					</div>
					<!--  账号设置  -->
					<!--<div v-if="menuIndex === 8">
						<change-psw></change-psw>
					</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		resumelDetail
	} from "@/api/job.js"
	import {
		messageList,
		messageCount,
		dictDetail,
	} from "@/api/api.js"
	import {
		getMyStudyInfo,
		userInfo
	} from "@/api/user.js"
	import UserInfo from "@/views/mine/components/user-info";
	import NewsCenter from "@/views/mine/components/news-center";
	import MyResume from "@/views/mine/components/my-resume";
	import SendCollection from "@/views/mine/components/send-collection";
	import MyCourse from "@/views/mine/components/my-course";
	import MyExam from "@/views/mine/components/my-exam";
	import MyPapers from "@/views/mine/components/my-papers";
	import MyOrder from "@/views/mine/components/my-order";
	import ChangePsw from "@/views/mine/components/change-psw";
	export default {
		name: "mine",
		components: {
			ChangePsw,
			MyOrder,
			MyPapers,
			MyExam,
			MyCourse,
			SendCollection,
			MyResume,
			NewsCenter,
			UserInfo
		},
		data() {
			return {
				menuList: [
					'个人信息', '消息中心', '我的简历', '投递和收藏', '我的课程', '我的考试', '我的认证', '我的订单'
				],
				menuIndex: 0,
				// totalNews: 0, //消息总数'
				userInfo: {},
				salary: '',
				workStatusName:'',
				studyData: {
					certificateCount: 0, //证书数量
					courseCount: 0, //已学课程
					starCount: 0, //星级
					studyTime: '0小时0分钟', //学习时长
				}
			}
		},
		computed: {
			totalNews() {
				return this.$store.state.totalNewsNum;
			},
			hasResume() {
				return this.$store.state.userInfo.resumeId
			},
		},
		watch: {
			'$route.query.menuIndex': function() {
				let menuIndex = this.$route.query.menuIndex;
				if (menuIndex) {
					let tempIndex = menuIndex * 1;
					let cacheUserInfo = this.$store.state.userInfo;
					if (tempIndex == 2 &&
						(
							!cacheUserInfo.realName ||
							!cacheUserInfo.sex ||
							!cacheUserInfo.phone ||
							!cacheUserInfo.workingSeniority ||
							!cacheUserInfo.diploma ||
							!cacheUserInfo.email ||
							!cacheUserInfo.wechat ||
							!cacheUserInfo.birthday
						)
					) {
						this.$nextTick(() => {
							this.$message.warning('请先完善个人信息')
						})
						this.mineMenuChange(0);
						return false;
					}
					// else if(tempIndex==3 && cacheUserInfo.resumeId==-1){
					// 	this.$message.warning('请先完善个人简历信息')
					// 	this.mineMenuChange(2);
					// 	return false;
					// }
					else {
						this.menuIndex = tempIndex;
					}
				}
			}
		},
		mounted() {
			let menuIndex = this.$route.query.menuIndex;
			if (menuIndex) {
				let tempIndex = menuIndex * 1;
				let cacheUserInfo = this.$store.state.userInfo;
				if (tempIndex == 2 &&
					(
						!cacheUserInfo.realName ||
						!cacheUserInfo.sex ||
						!cacheUserInfo.phone ||
						!cacheUserInfo.workingSeniority ||
						!cacheUserInfo.diploma ||
						!cacheUserInfo.email ||
						!cacheUserInfo.wechat ||
						!cacheUserInfo.birthday
					)
				) {
					this.$nextTick(() => {
						this.$message.warning('请先完善个人信息')
					})
					this.mineMenuChange(0);
					return false;
				}
				// else if(tempIndex==3 && cacheUserInfo.resumeId==-1){
				// 	this.$message.warning('请先完善个人简历信息')
				// 	this.mineMenuChange(2);
				// 	return false;
				// }
				else {
					this.menuIndex = tempIndex;
				}
			}
			this.getUserInfo()
			this.getMySalary();
			this.getMessageNum();
			this.queryMyStudyInfo();
		},
		methods: {
			queryMyStudyInfo() {
				getMyStudyInfo().then(res => {
					this.studyData = res
				})
			},
			getMessageNum() {
				// messageList({current: 1,size: 10}).then(res=>{
				// 	this.totalNews = res.total;
				// })
				this.$store.dispatch('getTotalNewsNum')
			},
			updateUserInfo(e) {
				this.getUserInfo()
			},
			getUserInfo() {
				userInfo({}).then(res => {
					console.log(res)
					this.userInfo = res
				})
			},
			getMySalary() {
				resumelDetail({}).then(res => {
					this.workStatusName=res.workStatusName
					if (!!res.salary) {
						dictDetail({
							code: 'salary',
							dictKey: res.salary
						}).then(res => {
							this.salary = res.dictValue;
							
						})
					}
				})
			},
			mineMenuChange(e) {
				// this.menuIndex = e;
				this.$router.push({
					path: 'mine',
					query: {
						menuIndex: e
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.head-bar {
		background-image: url("../../assets/mine/user-center-bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		width: 100%;
		height: 200px;

		.avatar {
			width: 118px;
			height: 118px;
			box-shadow: 0 0 10px 0 rgba(40, 48, 137, 0.50);
			border-radius: 50%;
		}

		.status-tag {
			padding: 3px 10px;
			background: #eea906;
			border-radius: 5px;
			color: #fff;
		}

		.str-line {
			width: 1px;
			height: 40px;
			background: #fff;
			margin: 0 30px;
		}

		.sub-color {
			color: #CADAFF;
		}
	}

	.left-menu {
		width: 240px;

		.menu-title {
			width: 240px;
			background: linear-gradient(90deg, #52cafe, #87a5fc 100%);
			border-radius: 5px 5px 0 0;
			padding: 16px 0;
		}

		.menu-body {
			.menu-item {
				padding: 16px 0;
				width: 100%;
				background: #fff;

				&:hover {
					background: #e9f2ff;
					transition: all ease-in 0.2s;
				}
			}

			.active-menu {
				background: #e9f2ff;
			}
		}
	}

	.main-info {
		width: 940px;
	}

	.nums {
		background: #ff5918;
		// border-radius: 30px;
		border-radius: 50%;
		// padding: 1px 5px;
		// color: #fff;
		// font-size: 10px;
		width: 10px;
		height: 10px;
		position: absolute;
		right: 40px;
	}
</style>
